/* eslint-disable */
function *findRecursive(route) {
  if (!route) { return; }

  for (var i = 0; i< route.length; i++){
    var val = route[i];
    yield val;

    if (val.children) {
      yield *findRecursive(val.children);
    }
  }  
}

export const findPathWithAfterLogin = (routes) => {
  const stock = [];
  const route = findRecursive(routes);
  let result = route.next();

  while(!result.done){
    stock.push(result.value);
    result = route.next();
  }

  return stock.find(record => record.meta && (record.meta.authorizationType === 'afterLogin'));
};
